import Vue from "vue";
import Vuex from "vuex";
import gateway from "@/services/gateway";
import errors from "@/services/errors";
//import axios from "axios";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    publicKey: null, //of the account
    gatewayId: null,
    gatewayPublicKey: null,
    subtotal: null,
    showPrice: true, //default
    showAgreement: true, //default
    showInstallments: true, //default
    showSubmit: true, //default
    cardDetails: null
  },
  mutations: {
    SET_PUBLIC_KEY(state, payload) {
      state.publicKey = payload;
    },
    SET_GATEWAY_ID(state, payload) {
      state.gatewayId = payload;
    },
    SET_GATEWAY_PUBLIC_KEY(state, payload) {
      state.gatewayPublicKey = payload;
    },
    SET_SUBTOTAL(state, payload) {
      state.subtotal = payload;
      //window.alert(state.subtotal);
    },
    SET_SHOW_PRICE(state, payload) {
      state.showPrice = payload;
    },
    SET_SHOW_AGREEMENT(state, payload) {
      state.showAgreement = payload;
    },
    SET_SHOW_INSTALLMENTS(state, payload) {
      state.showInstallments = payload;
    },
    SET_SHOW_SUBMIT(state, payload) {
      state.showSubmit = payload;
    }
  },
  actions: {
    setPublicKey({ commit }, payload) {
      commit("SET_PUBLIC_KEY", payload);
    },
    setGatewayId({ commit }, payload) {
      if (typeof payload !== "number")
        console.log(`ERROR: cannot set gatewayId, it must be a number.`);
      else {
        commit("SET_GATEWAY_ID", payload);
      }
    },
    setGatewayPublicKey({ commit }, payload) {
      if (typeof payload !== "string")
        console.log(`ERROR: cannot set gatewayPublicKey, it must be a string.`);
      else commit("SET_GATEWAY_PUBLIC_KEY", payload);
    },
    setSubtotal({ commit }, payload) {
      if (isNaN(parseFloat(payload)))
        console.log(`ERROR: cannot set subtotal, it must be a number.`);
      else commit("SET_SUBTOTAL", parseFloat(payload));
    },
    setShowPrice({ commit }, payload) {
      if (typeof payload !== "boolean")
        console.log(`ERROR: cannot set showPrice, it must be a boolean value.`);
      else commit("SET_SHOW_PRICE", payload);
    },
    setShowAgreement({ commit }, payload) {
      if (typeof payload !== "boolean")
        console.log(
          `ERROR: cannot set showAgreement, it must be a boolean value.`
        );
      else commit("SET_SHOW_AGREEMENT", payload);
    },
    setShowInstallments({ commit }, payload) {
      if (typeof payload !== "boolean")
        console.log(
          `ERROR: cannot set showInstallments, it must be a boolean value.`
        );
      else commit("SET_SHOW_INSTALLMENTS", payload);
    },
    setShowSubmit({ commit }, payload) {
      if (typeof payload !== "boolean")
        console.log(
          `ERROR: cannot set showSubmit, it must be a boolean value.`
        );
      else commit("SET_SHOW_SUBMIT", payload);
    },
    async createCardToken({ commit, state }, { cardDetails }) {
      try {
        const x = 10;
        //console.log(state.gatewayId);
        //console.log(state.gatewayPublicKey);
        const tempToken = await gateway.createTempToken(
          state.gatewayId,
          state.gatewayPublicKey,
          null,
          {
            cardName: cardDetails.cardName,
            cardNumber: cardDetails.cardNumber,
            cardDNI: cardDetails.cardDNI,
            expirationDate: cardDetails.expirationDate,
            CVC: cardDetails.CVC
          }
        );
        const y = 20;
        return tempToken;
      } catch (err) {
        //console.log(`Payment form store err: ${err}`);
        throw err;
      }
    },
    async getPaymentSettings({ commit, state }) {
      try {
        let res = null;

        //if (state.subtotal > 0) {
        let installments = state.showInstallments == true ? true : false;

        res = await Vue.prototype.$axios.get(
          `/public/accounts/${state.publicKey}/payment-settings`,
          {
            params: {
              amount: state.subtotal,
              installments
            }
          }
        );

        if (res.status != 200) {
          const err = errors.handleHTTPError(res);
          throw err;
        } else {
          commit("SET_GATEWAY_ID", res.data.gatewayId);
          commit("SET_GATEWAY_PUBLIC_KEY", res.data.gatewayPublicKey);
        }
        //} else
        //  throw new Error("Error in getPaymentSettings, subtotal is not set.");

        return res.data;
      } catch (err) {
        throw err;
      }
    },
    async getInstallmentOptions({ commit }, { publicKey, amount }) {
      try {
        //const payload = { amount };
        const res = await Vue.prototype.$axios.get("/public/installments", {
          params: {
            publicKey,
            amount
          }
        });
        let installmentOptions;
        if (Array.isArray(res.data)) {
          installmentOptions = res.data;
        } else
          console.log(`Error getting installmentOptions. 
          Response: ${res.data.message}`);

        return installmentOptions;
      } catch (err) {
        throw err;
      }
    },
    async getPaymentCouriers({ commit }, publicKey) {
      try {
        //const payload = { amount };
        const x = 10;
        const res = await Vue.prototype.$axios.get("/public/payment-couriers", {
          params: { publicKey }
        });
        const y = 20;
        return res.data;
      } catch (err) {
        throw err;
      }
    }
    /*
    async pay({ commit }, { cardDetails }) {
      //PRE: precisa un captcha v2, los datos de la tarjeta y el email del usuario que esta haciendo la suscripción
      //POST:
      //1) llama al backend subscribeStep1 que corrobora el captcha y crea el usuario(si no existe) y la transacción vacia
      //2) llama al a)tokens, b)payments y c)cardtokens de decidir para guardar la tarjeta y tomar el token
      //3) llama el backend subscribeStep2 que termina de ingresar los datos de transacción inicial ($1) y los datos de la tarjeta

      try {
        //PASO 1: ingreso los datos de la tarjeta en el tokenizador de decidir y valido
        //que los datos de la tarjeta sean válidos

        const tokenRes = await gateway.createTempToken(null, {
          cardName: cardDetails.cardName,
          cardNumber: cardDetails.cardNumber,
          expirationDate: cardDetails.expirationDate,
          CVC: cardDetails.CVC
        });
        const x = 10;
        if (tokenRes.status != 201) {
          tokenRes.errorName = "DecidirGatewayError";
          const err = errors.handleHTTPError(tokenRes);
          throw err;
        }
        const y = 10;
        return tokenRes.data;
        //por ahora por el flujo con india, este próximo call lo van a hacer desde el servidor de harmony.
        //PASO 2: creo el usuario, la tarjeta y la transacción en el backend para
        //tener un userId y transactionId
        
        const res = await Vue.prototype.$axios.post("/public/pay", {
          clientCode,
          clientFirstName,
          clientLastName,
          clientPhone,
          clientEmail,
          costCenterId,
          businessUnitId,
          sellerUserId,
          cardToken: tokenRes.data.id,
          paymentCourierCode: cardDetails.cardType,
          cardSecurityCode: cardDetails.CVC,
          cardBin: tokenRes.data.bin,
          lastFourDigits: tokenRes.data.last_four_digits,
          expirationDate: cardDetails.expirationDate,
          cardName: cardDetails.cardName,
          installments
        });
        if (res.status != 201) {
          const err = errors.handleHTTPError(subscribeRes);
          throw err;
        }
        return res.data;
        
      } catch (err) {
        throw err;
      }
    }*/
  },
  getters: {
    publicKey: state => {
      return state.publicKey;
    },
    gatewayId: state => {
      return state.gatewayId;
    },
    gatewayPublicKey: state => {
      return state.gatewayPublicKey;
    },
    subtotal: state => {
      return state.subtotal;
    },
    showPrice: state => {
      return state.showPrice;
    },
    showAgreement: state => {
      return state.showAgreement;
    },
    showInstallments: state => {
      return state.showInstallments;
    },
    showSubmit: state => {
      return state.showSubmit;
    }
  }
};
